import PropTypes from 'prop-types';
import './style.scss';

const AddOnDisabled = ({ isAddOnDisabled, addOnExpired }) => {
    return (
        <div className='disable-add-on-container'>
            {isAddOnDisabled ? (
                <div>
                    <p className='disable-add-on-heading'>Add-Ons have been disabled by the admin.</p>
                    <p className='disable-add-on-subtext'>
                        Admin has disabled Add-Ons for your organization. You can still appreciate your peer by{' '}
                        <span>sending a new recognition.</span>
                    </p>
                </div>
            ) : addOnExpired ? (
                <div>
                    <p className='disable-add-on-subtext'>
                        <span>Add Ons</span> for this recognition have expired on <span>{addOnExpired}</span>. Please
                        try to give a new recognition if you want to recognise the peers for their amazing work.
                    </p>
                </div>
            ) : null}
        </div>
    );
};

AddOnDisabled.propTypes = {
    isAddOnDisabled: PropTypes.bool.isRequired,
    addOnExpired: PropTypes.string.isRequired,
};

export default AddOnDisabled;
